export default {
  charts: {
    downloadToPng: 'Descargar gráfico a PNG',
    warning: {
      selectOneDimensionAndOneMeasure: 'Por favor, seleccione una dimensión y una medida para mostrar el gráfico',
      selectAtLeast2NumericAttributes: 'Por favor, seleccione 2 atributos numéricos para mostrar el gráfico',
      tooManyItemsToShowChart:
        'Demasiados elementos para mostrar el gráfico;\nse esperan un máximo de {{maxItems}} elementos.\nPor favor, refine su consulta (por ejemplo, añadiendo un filtro) para reducir el número de elementos.\n',
    },
    type: {
      area: 'Gráfico de área',
      bar: 'Gráfico de barras',
      line: 'Gráfico de líneas',
      pie: 'Gráfico circular',
      scatter: 'Gráfico de dispersión',
    },
  },
  dataQuery: {
    deleteConfirmMessage: '¿Eliminar la consulta "{{name}}"?',
    displayType: {
      chart: 'Gráfico',
      table: 'Tabla',
    },
    manageQueries: 'Administrar consultas',
    mode: {
      label: 'Modo:',
      aggregate: 'Agregar',
      raw: 'Crudo',
      rawEdit: 'Edición en bruto',
    },
    replaceQueryConfirmMessage: '¿Reemplazar la consulta actual por la seleccionada?',
    showCodes: 'Mostrar códigos',
  },
  editSelectedRecord: 'Editar registro seleccionado',
  filterAttributeTypes: 'Filtrar tipos de atributos',
  filterRecords: {
    buttonTitle: 'Filtrar',
    expressionEditorHeader: 'Expresión para filtrar registros',
  },
  invalidRecord: 'Registro no válido',
  nodeDefsSelector: {
    hide: 'Ocultar selector de definiciones de nodo',
    show: 'Mostrar selector de definiciones de nodo',
    nodeDefFrequency: '{{nodeDefLabel}} (frecuencia)',
  },
  records: {
    clone: 'Clonar',
    confirmDeleteRecord: '¿Eliminar el registro "{{keyValues}}"?',
    confirmDeleteSelectedRecord_one: '¿Eliminar el registro seleccionado?',
    confirmDeleteSelectedRecord_other: '¿Eliminar los {{count}} registros seleccionados?',
    confirmMergeSelectedRecords:
      '### ¿Fusionar los registros seleccionados en uno?\n\n- el registro "fuente" se fusionará con el registro "destino":\n  - fuente: [{{sourceRecordKeys}}], modificado {{sourceRecordModifiedDate}};\n  - destino: [{{targetRecordKeys}}], modificado {{targetRecordModifiedDate}};\n\n- se mostrará una vista previa del resultado antes de realizar la fusión;\n\n- cuando se confirme la fusión, **el registro fuente SERÁ ELIMINADO**',
    confirmUpdateRecordsStep: '¿Mover el/los {{count}} registro(s) seleccionado(s) de {{stepFrom}} a {{stepTo}}?',
    confirmUpdateRecordOwner: '¿Cambiar el propietario del registro seleccionado a {{ownerName}}?',
    confirmValidateAllRecords: `¿Volver a validar todos los registros?\n\nEsto puede tardar varios minutos.`,
    deleteRecord: 'Eliminar registro',
    demoteAllRecordsFromAnalysis: 'Análisis -> Limpieza',
    demoteAllRecordsFromCleansing: 'Limpieza -> Entrada',
    editRecord: 'Editar registro',
    exportList: 'Exportar lista',
    exportData: 'Exportar datos',
    exportDataSummary: 'Exportar resumen de datos',
    exportRecordDocx: 'Exportar registro (Word)',
    filterPlaceholder: 'Filtrar por claves o propietario',
    merge: {
      label: 'Fusionar',
      confirmLabel: 'Confirmar fusión',
      confirmTooManyDifferencesMessage:
        '**Demasiadas diferencias**. \nParece que los registros son muy diferentes entre sí. \nMuchos atributos (~{{nodesUpdated}}) se actualizarán durante la fusión. \n¿Continuar con la vista previa de la fusión?',
      noChangesWillBeApplied: 'No se aplicarían cambios al registro de destino. \nNo se puede realizar la fusión.',
      performedSuccessfullyMessage: '¡Fusión de registros realizada correctamente!',
      previewTitle: 'Vista previa de la fusión (registro {{keyValues}})',
    },
    noRecordsAdded: 'No se añadieron registros',
    noRecordsAddedForThisSearch: 'No se encontraron registros',
    noSelectedRecordsInStep: 'No hay registros seleccionados en el paso {{step}}',
    owner: 'Propietario',
    promoteAllRecordsToAnalysis: 'Limpieza -> Análisis',
    promoteAllRecordsToCleansing: 'Entrada -> Limpieza',
    step: 'Paso',
    updateRecordsStep: 'Actualizar paso de registros',
    validateAll: 'Validar todo',
    viewRecord: 'Ver registro',
  },
  recordsClone: {
    title: 'Clonación de registros',
    fromCycle: 'Del ciclo',
    toCycle: 'Al ciclo',
    confirmClone:
      '¿Clonar registros del ciclo {{cycleFrom}} al ciclo {{cycleTo}}?\n(Solo se clonarán los registros que aún no estén en el ciclo {{cycleTo}})',
    startCloning: 'Iniciar clonación',
    cloneComplete: 'Clonación completada. Se clonaron {{recordsCloned}} registros de {{cycleFrom}} a {{cycleTo}}',
    error: {
      cycleToMissing: 'Por favor, seleccione "Al ciclo"',
      cycleToMustBeDifferentFromCycleFrom: '"Al ciclo" debe ser diferente de "Del ciclo"',
    },
    source: {
      label: 'Fuente',
      allRecords: 'Todos los registros en el ciclo {{cycleFrom}} que aún no estén en el ciclo {{cycleTo}}',
      selectedRecords: 'Solo los {{selectedRecordsCount}} registros seleccionados',
    },
  },
  recordDeleted_one: '¡Registro eliminado correctamente!',
  recordDeleted_other: '¡{{count}} registros eliminados correctamente!',
  recordsSource: {
    label: 'Fuente',
  },
  recordsUpdated: '¡{{count}} registros actualizados correctamente!',
  rowNum: 'Fila #',
  selectedAttributes: 'Atributos seleccionados:',
  selectedDimensions: 'Dimensiones seleccionadas',
  selectedMeasures: 'Medidas seleccionadas',
  sortableItemsInfo: 'Arrastre y suelte para ordenarlos',
  showValidationReport: 'Mostrar informe de validación',
  sort: 'Ordenar',
  dataExport: {
    source: {
      label: 'Fuente',
      allRecords: 'Todos los registros',
      filteredRecords: 'Solo registros filtrados',
      selectedRecord: 'Solo registro seleccionado',
      selectedRecord_other: 'Solo {{count}} registros seleccionados',
    },
    title: 'Exportar datos',
  },
  dataVis: {
    errorLoadingData: 'Error al cargar datos',
    noData: 'Esta consulta no devolvió datos',
    noSelection:
      'Por favor, haga su selección usando el panel lateral izquierdo o seleccione una consulta existente de "Administrar consultas"',
  },
  viewSelectedRecord: 'Ver registro seleccionado',
  mapView: {
    layersControl: {
      baseLayers: 'Capas base',
      inputData: 'Datos de entrada',
      preloadedLayers: 'Capas precargadas',
      samplingPointData: 'Datos de puntos de muestreo',
    },
    layersPanel: {
      hidePanel: 'Ocultar panel',
      showPanel: 'Mostrar panel',
      markers: '{{count}} marcadores',
      markers_one: '{{count}} marcador',
      markers_other: '{{count}} marcadores',
    },
  },
}
